<div class="card">
    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>
